import { useTranslation } from 'react-i18next';
import { Loader } from '@applyft-web/ui-components';
import { useGoogleAuth, useGoogleFontPreload } from '../../core/hooks';
import * as S from './styled';

export const GoogleSignInButton = ({
  screenId = '',
  customStyles = '',
}: {
  screenId?: string;
  customStyles?: string;
}) => {
  const { t } = useTranslation();
  const { isBtnPreloaded, handleCustomButtonClick } = useGoogleAuth(screenId);

  useGoogleFontPreload();

  return (
    <>
      {!isBtnPreloaded && <Loader customStyles={'background-color: #ffffff'} />}
      <S.GoogleButtonWrapper>
        <S.GoogleButtonContainer id="googleSignInButton" />
        <S.CustomGoogleButton onClick={handleCustomButtonClick} customStyles={customStyles}>
          <S.GoogleLogo src="/assets/images/google_btn.svg" alt="Google" />
          {t('continue_with_google')}
        </S.CustomGoogleButton>
      </S.GoogleButtonWrapper>
      <S.Separator>
        <span>{t('or')}</span>
      </S.Separator>
    </>
  );
};
